/** Format buyer-facing unit names using the configured number, never the row code. */
export function formatUnitLabel(type: string, number: string, rowLabel?: string | null): string {
  const prefix = type.trim()
  let value = number.trim()
  if (prefix && value.toLocaleLowerCase().startsWith(`${prefix.toLocaleLowerCase()} `)) {
    value = value.slice(prefix.length).trim()
  }
  if (rowLabel && value.toLocaleLowerCase().startsWith(`${rowLabel.trim().toLocaleLowerCase()}-`)) {
    value = value.slice(rowLabel.trim().length + 1)
  }
  // Legacy carts may only contain the technical row-number code.
  if (prefix) value = value.replace(/^[A-Za-z]+-(\d+[A-Za-z]?)$/u, '$1')
  return [prefix, value].filter(Boolean).join(' ')
}
